import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { IResponseData } from '../../interfaces/response-data';
import { IVoucherState } from '../../interfaces/voucherState';
import { IBookingConfirmation } from '../../interfaces/booking-confirmation';
import { AccountApi } from '@limehome/account-api-client';
import { AuthService } from '../auth/auth.service';
import { ResponseData } from '@shared/common/types/response-data.type';
import { ReservationTokenReq } from '../../interfaces/booking.interface';

@Injectable({
  providedIn: 'root'
})
export class BookingService {
  private readonly apiBase = environment.apiBaseUrl;

  constructor(
    private readonly http: HttpClient,
    private readonly accountApi: AccountApi,
    private readonly authService: AuthService
  ) {}

  checkVoucher(propertyId: number, unitGroupId: number, voucherCode: string): Observable<IResponseData<IVoucherState>> {
    return this.http.get<IResponseData<IVoucherState>>(
      `${this.apiBase}/offers/vouchers?propertyId=${propertyId}&unitGroupId=${unitGroupId}&voucherCode=${voucherCode}`
    );
  }

  checkVoucherForMultipleUnitGroups(
    propertyId: number,
    unitGroupIds: number[],
    voucherCode: string
  ): Observable<IResponseData<IVoucherState>> {
    return this.http.get<IResponseData<IVoucherState>>(
      `${this.apiBase}/offers/vouchers?propertyId=${propertyId}&unitGroupIds=${unitGroupIds}&voucherCode=${voucherCode}`
    );
  }

  public getBookingRequestData(bookingRequestId): Observable<IResponseData<IBookingConfirmation>> {
    return this.http.get<IResponseData<IBookingConfirmation>>(
      `${this.apiBase}/booking-requests/${bookingRequestId}/confirmation/`
    );
  }

  getReservationToken(data: ReservationTokenReq): Observable<ResponseData<{ reservationToken: string }>> {
    return this.http.post<ResponseData<{ reservationToken: string }>>(
      `${environment.bookingApiBaseUrl}/public/reservation/token`,
      data
    );
  }
}
